import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styled';

function NotificationOverlay({ visible, message }) {
  return (
    <Styled.NotificationBody visible={visible}>
      <Styled.NotificationContent>{message}</Styled.NotificationContent>
    </Styled.NotificationBody>
  );
}

NotificationOverlay.propTypes = {
  /** Controls the visibility of the notification */
  visible: PropTypes.bool.isRequired,
  /** The message to display on the notification */
  message: PropTypes.string,
};

NotificationOverlay.defaultProps = {
  message: '',
};

export default NotificationOverlay;
